import { render, staticRenderFns } from "./DonutChart17.vue?vue&type=template&id=70d7b85b&scoped=true"
import script from "./DonutChart17.vue?vue&type=script&lang=js"
export * from "./DonutChart17.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d7b85b",
  null
  
)

export default component.exports